import * as z from "zod";

const createEnv = () => {
  const EnvSchema = z.object({
    DEV: z
      .string()
      .refine((s) => s === "true" || s === "false")
      .transform((s) => s === "true"),
    API_ENDPOINT: z.string(),
    PORT: z.string(),
    TELEGRAM_URL: z.string(),
  });

  const envVars = Object.entries(import.meta.env).reduce<Record<string, string>>((acc, curr) => {
    const [key, value] = curr;
    if (key.startsWith("FARM_")) {
      acc[key.replace("FARM_", "")] = value;
    }
    return acc;
  }, {});

  const parsedEnv = EnvSchema.safeParse(envVars);

  if (!parsedEnv.success) {
    throw new Error(
      `Invalid env provided.
The following variables are missing or invalid:
${Object.entries(parsedEnv.error.flatten().fieldErrors)
  .map(([k, v]) => `- ${k}: ${v}`)
  .join("\n")}
`,
    );
  }

  return parsedEnv.data;
};

export const env = createEnv();
